// extracted by mini-css-extract-plugin
export default {"form":"ChamadoForm_form__DV2x2","select":"ChamadoForm_select__0yCxu"};